export default __webpack_public_path__ + "_/images/p2p/bank-logotype-b8947f5f086ab44625f67d1e1ebff01c94c18ffdd76d207dc33a7273cf464496.svg";